// Using object.freeze because this is consumed by non-ts files

export const CheckError = Object.freeze({
  NET_NEGATIVE_PAY: 'NET_NEGATIVE_PAY',
  PAYROLL_ALREADY_APPROVED: 'PAYROLL_ALREADY_APPROVED',
});

export default null;
